import { gql } from "@apollo/client";
import RaceFragments from "./RaceFragment";

const TrackFragment = {
  entry: gql`
    fragment Track on Track {
      id
      featured
      name
      perfAbbr
      code
      hasAboveTheLinePromo(product: $product, brand: $brand)
      location {
        country
      }
      currentRace {
        ...Race
      }
    }
    ${RaceFragments.entry}
  `
};

export default TrackFragment;
